module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile),
      expression: "profile"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "profiles"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.perfis), function(perfil) {
    return _c('option', {
      domProps: {
        "value": perfil
      }
    }, [_vm._v(_vm._s(perfil.name))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75faa27f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/profiles.vue
// module id = 2017
// module chunks = 1